export default {
  'lg': {
    'fr': 'https://www.youtube.com/watch?v=9Bl_tcEKCaQ',
    'es': 'https://www.youtube.com/watch?v=Mp8I40GADc8',
    'it': 'https://www.youtube.com/watch?v=mPgry-KOq-o',
    'de': 'https://www.youtube.com/watch?v=S1rEupr6rG0',
    'en': 'https://www.youtube.com/watch?v=DTat5S_J4ys'
  },
  /*
  'samsung': {
    'fr': 'https://www.youtube.com/watch?v=y15CZgqdu7s',
    'es': 'https://www.youtube.com/watch?v=xyP1WRnzRRg',
    'it': 'https://www.youtube.com/watch?v=H7x6js8JCZs',
    'de': 'https://www.youtube.com/watch?v=8r73FUChU8o',
    'en': 'https://www.youtube.com/watch?v=TV1L_jBx6j4'
  },
   */
  'philips': {
    'fr': 'https://www.youtube.com/watch?v=4d0zZFlFgCk',
    'es': 'https://www.youtube.com/watch?v=MSCcZ90KZXw',
    'it': 'https://www.youtube.com/watch?v=BkYc1QXuJJI',
    'de': 'https://www.youtube.com/watch?v=7v3xK2_H7Fw',
    'en': 'https://www.youtube.com/watch?v=xQidLPEEzjg'
  },
  'chromecast': {
    'fr': 'https://www.youtube.com/watch?v=IhhIOYJAgbg',
    'es': 'https://www.youtube.com/watch?v=Sigxeog1YfA',
    'it': 'https://www.youtube.com/watch?v=tQF_5yJpmRA',
    'de': 'https://www.youtube.com/watch?v=I-8oXOZwrLA',
    'en': 'https://www.youtube.com/watch?v=ZlvAHmXlPsk'
  },
  'chromecast_standalone': {
    'fr': 'https://www.youtube.com/watch?v=kpIHyM11ZO0',
    'es': 'https://www.youtube.com/watch?v=3F6k1Xsq-oE',
    'it': 'https://www.youtube.com/watch?v=KR9S6Go6R7w',
    'de': 'https://www.youtube.com/watch?v=BrXg50Wh16Q',
    'en': 'https://www.youtube.com/watch?v=LAhdjj_r1Bo'
  }
}
